import {useState} from "react";
import {Button, Form, Modal} from "semantic-ui-react";
import {useAppDispatch} from "../../app/hooks";
import {CreateNewEmployee} from "./TablesActions";
import { useTranslation } from "react-i18next";
interface IEmployeeModal {
  open: boolean;
  onClose: () => void;
}

export const EmployeeModal = ({open, onClose}: IEmployeeModal) => {
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const {t} = useTranslation();
  const onInputChange = (e: any) => {
    const {value} = e.target;
    setEmailError(null);
    setEmail(value);
  };

  const onSubmit = () => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!emailRegex.test(email)) {
      setEmailError(t("enter_valid_email"));
      return;
    }
    dispatch(CreateNewEmployee(email));
    onHide();
  };

  const onHide = () => {
    setEmail("");
    setEmailError(null);
    onClose();
  };

  return (
    <Modal size="small" closeIcon onClose={onHide} open={open}>
      <Modal.Header>{t("add_new_user")}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={onSubmit}>
          <Form.Field required>
            <label>{t("email")}</label>
            <Form.Input autoFocus placeholder={"user@gmc.lt"} type="email" required name="email" value={email} onChange={onInputChange} error={emailError ? {content: emailError, pointing: "below"} : false} />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" basic onClick={onHide}>
          {t("cancel_btn")}
        </Button>
        <Button color="green" basic type="submit" onClick={onSubmit}>
          {t("create_btn")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
